/* ══════════════════════════════════════════
   Suche, die Akzente übersieht
   ──────────────────────────────────────────
   „malin" findet „Målin", „muller" findet „Müller", „strasse" findet
   „Straße". Gleiche Regeln wie backend/src/server/suchmuster.js: Die
   Server-Suche (Anmeldungen, Personen) und die Suche im Browser (Auswahl-
   felder, Check-in) sollen dieselben Treffer liefern.

   Beide Seiten werden gefaltet und dann verglichen. Deutsche Umlaute werden
   dabei zu ae/oe/ue: So treffen sich „Müller" und „Mueller" in beide
   Richtungen. Reine Funktionen, kein React.
   ══════════════════════════════════════════ */

/* Zeichen, die NFD nicht in Grundbuchstabe + Akzent zerlegt. */
const FALTUNG = { ß: 'ss', æ: 'ae', œ: 'oe', ø: 'o', ł: 'l', đ: 'd', ı: 'i', ä: 'ae', ö: 'oe', ü: 'ue' };

export function falte(s) {
  return String(s ?? '')
    .toLowerCase()
    .replace(/[ßæœøłđıäöü]/g, (c) => FALTUNG[c])
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/* Ein „u" in der Eingabe soll auch das ü im Text treffen („muller" →
   „Müller"). Gefaltet steht dort aber „ue". Deshalb wird der Text zusätzlich
   mit einfach gestrichenen Umlauten verglichen. */
const ohneUmlautE = (s) =>
  String(s ?? '')
    .toLowerCase()
    .replace(/[äöü]/g, (c) => ({ ä: 'a', ö: 'o', ü: 'u' })[c]);

/* true, wenn `suche` (getrimmt) irgendwo in `text` vorkommt — Groß/klein und
   Akzente egal. Leere Suche passt immer. */
export function passt(text, suche) {
  const q = falte(String(suche ?? '').trim());
  if (!q) return true;
  return falte(text).includes(q) || falte(ohneUmlautE(text)).includes(q);
}
